// src/components/AddMemberModal.jsx
import React, { useState, useEffect, useRef } from "react";
import "./AddMemberModal.css";

const AddMemberModal = ({ onClose, onSubmit }) => {
  const [mobile, setMobile] = useState("");
  const [shake, setShake] = useState(false);
  const [success, setSuccess] = useState(false);

  const modalRef = useRef(null);
  const inputRef = useRef(null);

  // Auto-focus input
  useEffect(() => {
    setTimeout(() => inputRef.current?.focus(), 200);
  }, []);

  // Swipe-to-close gesture (touch drag)
  useEffect(() => {
    let startY = 0;

    const modal = modalRef.current;

    const onTouchStart = (e) => (startY = e.touches[0].clientY);

    const onTouchMove = (e) => {
      const currentY = e.touches[0].clientY;
      const diff = currentY - startY;

      if (diff > 30) {
        modal.classList.add("slide-down");
      }
    };

    const onTouchEnd = (e) => {
      const currentY = e.changedTouches[0].clientY;
      const diff = currentY - startY;

      if (diff > 80) onClose();
      else modal.classList.remove("slide-down");
    };

    modal.addEventListener("touchstart", onTouchStart);
    modal.addEventListener("touchmove", onTouchMove);
    modal.addEventListener("touchend", onTouchEnd);

    return () => {
      modal.removeEventListener("touchstart", onTouchStart);
      modal.removeEventListener("touchmove", onTouchMove);
      modal.removeEventListener("touchend", onTouchEnd);
    };
  }, []);

  // SUBMIT
  const handleSubmit = (e) => {
    e.preventDefault();

    if (mobile.length !== 10) {
      setShake(true);
      setTimeout(() => setShake(false), 500);
      return;
    }

    setSuccess(true);

    setTimeout(() => {
      onSubmit({ mobile });
      onClose();
    }, 800);
  };

  return (
    <>
      <div className="member-backdrop" onClick={onClose}></div>

      <div className="member-modal slide-up" ref={modalRef}>

        {/* Grab Handle */}
        <div className="member-grab"></div>

        {/* HEADER */}
        <div className="member-header gradient-blue">
          <div className="member-header-icon">👤</div>
          <h5 className="member-title">Add Member</h5>
          <button className="member-close" onClick={onClose}>✕</button>
        </div>

        {/* SUCCESS CHECKMARK */}
        {success && (
          <div className="success-check">
            ✔ Member Added!
          </div>
        )}

        {/* BODY */}
        {!success && (
          <div className="member-body">
            <form onSubmit={handleSubmit}>

              {/* Mobile field */}
              <div className={`member-field ${shake ? "shake" : ""}`}>
                <label>Mobile Number</label>

                <div className="input-icon-box">
                  <i className="bi bi-telephone-fill input-icon"></i>
                  <input
                    ref={inputRef}
                    type="text"
                    className="member-input"
                    value={mobile}
                    maxLength="10"
                    onChange={(e) => setMobile(e.target.value)}
                    placeholder="Enter 10-digit number"
                  />
                </div>
              </div>

              {/* Buttons */}
              <div className="member-actions">
                <button type="button" className="btn-cancel ripple" onClick={onClose}>
                  Cancel
                </button>
                <button type="submit" className="btn-save gradient-blue-btn ripple">
                  Add Member
                </button>
              </div>

            </form>
          </div>
        )}

      </div>
    </>
  );
};

export default AddMemberModal;
